export default __webpack_public_path__ + "static/media/kubacloud.7911a8ca.png";